<div class="p8-bdc_settings-page__container" fxLayout="column">
  <div class="p8-bdc_settings-page__content-container" fxFlex="grow">
    <ng-content></ng-content>
  </div>
  <ng-content select="p8-settings-footer"></ng-content>
</div>
